import { PlusCircleIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const CAdd = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <PlusCircleIcon {...rest} size={Sizes[size]} color={fill} />;
};

CAdd.displayName = 'CAdd';
